import cx from 'classnames';

import styles from './forget-password.module.scss';

import { Button, InputType } from '@greenkub-fronts/shared/ui';
import { Link } from 'react-router-dom';

import useForgetPasswordFormFeature from '../../../feature/forget-password-form-feature/forget-password-form-feature';
import { Form, Input } from 'antd';
import { FormItem } from 'react-hook-form-antd';

export function ForgetPasswordForm() {
  const { handleSubmit, onSubmit, successMsg, errorMsg, isLoading, control } =
    useForgetPasswordFormFeature();

  return (
    <Form className={styles['LoginForm']} onFinish={handleSubmit(onSubmit)}>
      <FormItem control={control} name="email">
        <Input
          size={'large'}
          type="email"
          placeholder="Email"
          defaultValue=""
        />
      </FormItem>

      <div className={styles['LoginActions']}>
        <div>
          <Link to="/login">Connexion</Link>
        </div>
      </div>

      {/* ERREUR DE VALIDATION */}
      <div>
        <p className={cx(styles['FormMsg'], styles['IsError'])}>{errorMsg}</p>
      </div>
      <div>
        <p className={cx(styles['FormMsg'], styles['IsSuccess'])}>
          {successMsg}
        </p>
      </div>

      <Button
        loading={isLoading}
        className={styles['LoginSubmit']}
        inputType={InputType.SUBMIT}
        label="Réinitialiser mon mot de passe"
      />
    </Form>
  );
}

export default ForgetPasswordForm;
